import {IconButton, TextField} from '@mui/material';
import styled from 'styled-components';
import {media, theme, tokens} from '../../../theme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const StyledForm = styled.form<{ $hasFile: boolean; $isMultiLine: boolean; $isDraggingOver?: boolean }>`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: ${(props) => (props.$hasFile ? '14px' : '12px')};
    
    border: 1px solid ${({$isDraggingOver, theme}) => ($isDraggingOver 
            ? theme.palette.action.dragDrop
            : theme.palette.dividers.strong
    )};
    
    border-radius: ${tokens.radius.lg};
    
    background: ${({$isDraggingOver, theme}) => ($isDraggingOver 
            ? theme.palette.action.hoveredDropzone 
            : theme.palette.background.input
    )};
    
    transition: all 0.2s ease-in-out;

    @media (max-width: 680px) {
        padding: 0 0 4px 0;
    }

    ${media.smPlus} {
        padding: ${(props) => (props.$hasFile ? '12px' : '10px')};
    }

    ${media.md} {
        padding: ${(props) => (props.$hasFile ? '11px' : '8px')};
    }


    &:hover {
        border: 1px solid ${({ theme }) => theme.palette.dividers.focus};
        box-shadow: 0 2px 8px rgba(30, 41, 59, 0.1); // primary main
    }
    
    &:focus-within {
        border: 1px solid ${({ theme }) => theme.palette.dividers.focus};
        box-shadow: 0 2px 8px rgba(30, 41, 59, 0.1); // primary main
    }
`;

export const MicrophoneButton = styled(IconButton)<{ $isRecording: boolean }>`
    color: ${(props) => (props.$isRecording ? 'red' : theme.palette.primary.main) + ' !important'};
    width: 36px;
    height: 36px;
    padding: 5px !important;

    &:hover:not(:disabled) {
        background: rgba(224, 221, 222, 0.5) !important;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    svg {
        width: 20px;
        height: 20px;
    }

    ${media.smPlus} {
        width: 32px;
        height: 32px;
    }
`

export const GlobeButton = styled(IconButton)<{ $isInternetSelected: boolean }>`
    background-color: ${(props) => (props.$isInternetSelected ? 'rgba(0, 0, 0, 0.1) !important' : 'transparent !important')};
    width: 36px;
    height: 36px;
    padding: 5px !important;

    &:hover:not(:disabled) {
        background: rgba(224, 221, 222, 0.5) !important;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    svg {
        width: 20px;
        height: 20px;
        
        path {
            stroke: ${theme.palette.primary.main};
        }
    }

    ${media.smPlus} {
        width: 32px;
        height: 32px;
    }
`;

export const InputActions = styled.div<{ $attachedFile: boolean; $isMultiLine: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    bottom: 3px;

    @media (max-width: 600px) {
        gap: 1px;
    }

    ${media.smPlus} {
        gap: 2px;
    }

    svg {
        width: 22px;
        height: 22px;
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;
`;

export const ActionsWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const SendButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    
    button {
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        &:disabled {
            opacity: 0.45;
        }

        
        svg {
            width: 22px;
            height: 22px;
        }
        
    }
`;

export const StyledTextField = styled(TextField)<{ $hasFile: boolean }>`
    & {
        flex: 1;
        border: none;
        width: 100%;
        margin-left: 8px;

        .MuiOutlinedInput-root {
            border: none;
            padding: 8px 8px 8px 0;
            position: relative;
            align-items: flex-end;
        }

         .MuiOutlinedInput-notchedOutline {
             display: none;
         }

         .MuiInputBase-input {
             padding: 0;
             line-height: 1.5;
         }
    }
`;

export const AvatarBlock = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: ${tokens.colors.blue500};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${tokens.colors.white};
    font-size: ${({theme}) => theme.typography.body1.fontSize};
    font-weight: ${tokens.fontWeight.semibold};
`;